// Internal Dependencies
import {
  PAGE_UPDATE,
  ROWS_PER_PAGE_UPDATE,
  NINJAS_SELECTED,
  NINJAS_ALL_SELECTED,
  NINJAS_SEARCH_STRING,
} from './action-types';

export const updatePageAction = pageNumber => ({
  type: PAGE_UPDATE,
  payload: pageNumber,
});

export const updateRowsPerPageAction = rows => ({
  type: ROWS_PER_PAGE_UPDATE,
  payload: rows,
});

export const selectedNinjasAction = ninjas => ({
  type: NINJAS_SELECTED,
  payload: ninjas,
});

export const selectAllNinjasAction = ninjas => ({
  type: NINJAS_ALL_SELECTED,
  payload: ninjas,
});

export const searchStringAction = searchString => ({
  type: NINJAS_SEARCH_STRING,
  payload: searchString,
});




/** WEBPACK FOOTER **
 ** ./src/state/ui/update-ninjas/actions/action-creators.js
 **/